const displayCookieConsentModal = () => window.evidon.notice.showOptions();

export default displayCookieConsentModal;
